'use strict';

angular.module('directives.GOVContact', ['helpers.mail'])

.directive('govContact', ['$window', function ($window) {
    return {
        transclude: true,
        scope: {
            subject: '@',
            govEmailAddress: '=?',
            govPhone: '=?',
            govMailTo: '=?',
            govDepartment: '=?'
        },
        controller: ['$scope', 'Mailto', function($scope, Mailto) {
            $scope.govEmailAddress = $scope.govEmailAddress || 'gov@investpsp.ca';
            $scope.govPhone = $scope.govPhone || 'x3621 | +1 514.218.3621';
            $scope.govDepartment = $scope.govDepartment || 'Internal audit';

            var optionsGovMailTo = { subject: $scope.subject };
            $scope.govMailTo = Mailto.url($scope.govEmailAddress, optionsGovMailTo);
        }],
        template: '<span><i class="fa fa-envelope-o"></i>&nbsp;<a ng-click="mailTo()" target="_top">{{ govEmailAddress }}</a>' +
                  '</span><span>&nbsp;&nbsp;<i class="fa fa-phone"></i>&nbsp;{{ govPhone }}</span>',
        link: function (scope, el, attrs, ctrl, transcludeFn) {
            var transcludedContent = transcludeFn();

            if (transcludedContent.length > 0) {
                transcludeFn(scope, function(clonedTranscludedContent) {
                    el.replaceWith(clonedTranscludedContent);
                });
            }

            scope.mailTo = function () {
                $window.top.location.href = scope.govMailTo;
            }
        }
    }
}]);
